import {FC, useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";


import SectionContent from "../../../components/sectionContent/sectionContent";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import ContractsList from "../../../pages/contracts/contractsList/contractsList";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import {useDispatch, useSelector} from "react-redux";
import {IUserOptions} from "../../../types/interfaces";
import toast from "react-hot-toast";
import ToastPopup from "../../../components/custom/toastPopup/toastPopup";
import {generateStyles} from "../../../utils/generateToastStyles";
import {reducerSetRequestStatus} from "../../../redux/reducer/contracts/reducers/reducerCoefficientList";
import {AppDispatch} from "../../../redux/reducer/store";

const requestStatusOptions = [
    {
        status: 0,
        errorMessage: "При добавлении произошла ошибка!",
    },
    {
        status: 202,
        successMessage: "Файл с коэффициентами проектов успешно доблен в очередь обработки! " +
                        "Результат загрузки можно посмотреть в разделе Выгрузки - Загрузка шаблонов",
    },
    {
        status: 404,
        errorMessage: "Запрощенный ресурс не найден",
    },
];

const availableButtons = [{
    claims: ["admin", "contracts:budget:coefficient:import"],
    component: (
        <HeaderBtn
            content="Загрузка коэффициентов бюджета"
            purpose="importCoefficients"
            modalTitle="Загрузка коэффициентов бюджета"
        />
    ),
},
];

const AdminContractsListSection: FC = () => {
    const dispatch = useDispatch<AppDispatch>();

    const {claims} = useSelector((state: IUserOptions) => state.user.user.data);
    const {requestStatus} = useSelector((state: any) => state.contracts.coefficients);

    const filteredAvailableButtons = availableButtons.filter((btn: any) => {
        return btn.claims?.length > 0 ? btn.claims.filter((claim: any) => claims.includes(claim)).length > 0 : true;
    });

    const buttonsContainerRef = useRef<any>(null);
    const [isOpenGroupBtn] = useState<boolean>(false);
    const [overflowedBtnsCount] = useState<number>(0);
    const displayedAvailableBtns = filteredAvailableButtons
        ?.slice(-(overflowedBtnsCount as number))
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });
    const displayedHeadBtns = filteredAvailableButtons
        ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
        ?.map((elem: any, index: number) => {
            return elem && <div key={index}>{elem?.component}</div>;
        });

    useEffect(() => {
        requestStatusOptions.forEach(
            (option: {
                status: number | string;
                successMessage?: string;
                errorMessage?: string | undefined;
            }) => {
                if (requestStatus === option.status) {
                    toast.dismiss();
                    toast(
                        (t) => (
                            <ToastPopup
                                title={
                                    option.successMessage
                                    ? option.successMessage
                                    : option.errorMessage
                                }
                                isSuccess={!!option.successMessage}
                                toast={toast}
                                t={t}
                            />
                        ),
                        generateStyles(!!option.successMessage)
                    );
                }
            }
        );

        setTimeout(() => {
            dispatch(reducerSetRequestStatus(null));
        }, 5000);
    }, [dispatch, requestStatus]);

    return (
        <div className="App">
            <Sidebar/>
            <SectionContent
                section="Контракты"
                pageName="contracts"
                title="Список контрактов"
                buttonsContainerRef={buttonsContainerRef}
                headBlockChildren={displayedHeadBtns}
                isOpenGroupBtn={isOpenGroupBtn}
                availableButtons={displayedAvailableBtns}
            >
                <div className="content__main">
                    <div className="btns">
                        <Link to="/contracts" className="tab">
                            <div className="buttons__btn --active">Мерчендайзинг</div>
                        </Link>
                    </div>
                    <ContractsList/>
                </div>
            </SectionContent>
        </div>
    );
};

export default AdminContractsListSection;